import axios from "@/config/axios.config";
import siteApi from "@/api/site";
import { instance as Toast } from "@/plugins/toast";
export const weixin = {
	config() {
		var url = encodeURIComponent(location.href.split("#")[0]);
		//var url = location.href.split("#")[0];
		var jsApiList = [
			"showAllNonBaseMenuItem",
			"hideAllNonBaseMenuItem",
			"hideMenuItems",
			"showMenuItems",
			"onMenuShareTimeline",
			"onMenuShareAppMessage",
			"onMenuShareQQ",
			"onMenuShareWeibo",
			"chooseImage",
			"uploadImage",
			// 预览图片
			"previewImage",
			// 获取地理位置
			"getLocation",
			"openLocation",
			// 扫码（二维码/条形码）
			"scanQRCode",
			// 微信充值
			"chooseWXPay"
		];

		axios({
			method: "get",
			url: siteApi.getWxConfigUrl,
			noToast: true,
			noLogin: true,
			params: {
				url
			},
			noToast: true
		}).then(data => {
			wx.config({
				debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
				appId: data.appId, // 必填，公众号的唯一标识
				timestamp: data.timestamp, // 必填，生成签名的时间戳
				nonceStr: data.nonceStr, // 必填，生成签名的随机串
				signature: data.signature, // 必填，签名，见附录1
				jsApiList: jsApiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
			});
		});
	},
	getLocation(cb, replace = false) {
		wx.ready(() => {
			wx.getLocation({
				type: "wgs84",
				success: res => {
					// 将微信坐标换成百度坐标
					let point = new BMap.Point(res.longitude, res.latitude);
					let convertor = new BMap.Convertor();
					convertor.translate([point], 1, 5, data => {
						if (data.status == 0) {
							cb && cb(data.points[0]);
						} else {
							Toast.show("坐标转换错误");
						}
					});
				},
				fail: () => {
					let link = `${window.location.origin}/error.html${window.location.search}`;
					// 默认跳转，特殊页面replace到error页面防止产生history
					if (replace) {
						window.location.replace(link);
					} else {
						window.location.href = link;
					}
				},
				cancel: () => {
					let link = `${window.location.origin}/error.html${window.location.search}`;
					// 默认跳转，特殊页面replace到error页面防止产生history
					if (replace) {
						window.location.replace(link);
					} else {
						window.location.href = link;
					}
				}
			});
		});
		let res = {
			lng: "121.318719",
			lat: "31.208818",
		};
		cb && cb(res);
	},
	openLocation(data) {
		wx.ready(() => {
			wx.openLocation(data);
		});
	},
	chooseImage(cb) {
		wx.ready(() => {
			wx.chooseImage({
				count: 1, // 默认9
				sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图，默认二者都有
				sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
				success: function(res) {
					var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
					cb && cb(localIds);
				}
			});
		});
	},
	uploadImage(localId, cb) {
		wx.ready(() => {
			wx.uploadImage({
				localId, // 需要上传的图片的本地ID，由chooseImage接口获得
				isShowProgressTips: 1, // 默认为1，显示进度提示
				success: function(res) {
					var serverId = res.serverId; // 返回图片的服务器端ID
					cb && cb(serverId);
				}
			});
		});
	},
	chooseWXPay(data, success, fail, cancel) {
		wx.ready(() => {
			wx.chooseWXPay({
				timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
				nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
				package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
				signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
				paySign: data.paySign, // 支付签名
				success: function(res) {
					// 支付成功后的回调函数
					success && success(res);
				},
				fail: function(res) {
					fail && fail(res);
				},
				cancel: function(res) {
					cancel && cancel(res);
				}
			});
		});
	},
	previewImage(current = "", urls = []) {
		wx.ready(() => {
			wx.previewImage({
				current, // 当前显示图片的http链接
				urls // 需要预览的图片http链接列表
			});
		});
	}
};
